export const CATEGORIES = {
  metabolic: { name: 'Metabolic Research', color: '#E54D2E', bg: '#FDF2E9', tag: 'GLP / GIP / ENERGETICS' },
  recovery: { name: 'Recovery Research', color: '#1F8A58', bg: '#ECFDF5', tag: 'TISSUE / REPAIR' },
  skin: { name: 'Skin / Beauty Research', color: '#D6336C', bg: '#FFF0F6', tag: 'EPIDERMAL / COPPER' },
  energy: { name: 'Energy / Mitochondrial', color: '#D97706', bg: '#FFFBEB', tag: 'NAD+ / ATP / MITO' },
  cognitive: { name: 'Cognitive / Sleep', color: '#6366F1', bg: '#EEF2FF', tag: 'NEURO / CIRCADIAN' },
  gh: { name: 'GH Axis', color: '#0D9488', bg: '#F0FDFA', tag: 'SECRETAGOGUES / GHRH' },
  specialty: { name: 'Specialty', color: '#A16207', bg: '#FEFCE8', tag: 'BLENDS / COMPLEXES' },
};

export const catOf = (key) =>
  CATEGORIES[key] || { name: key || 'Specialty', color: '#A16207', bg: '#FEFCE8', tag: '' };

export const STATUS_LABELS = {
  available: 'Available for Purchase',
  catalogue_only: 'Research Catalogue Only',
  enquiry_only: 'Enquiry Only',
  coming_soon: 'Coming Soon',
  register_interest: 'Register Interest',
  out_of_stock: 'Out of Stock',
  prescription_pathway: 'Prescription Pathway',
  hidden: 'Hidden',
};

export const ORDER_STATUSES = [
  'new', 'awaiting_payment', 'payment_pending', 'paid', 'processing',
  'dispatched', 'completed', 'cancelled', 'refunded', 'manual_review',
];

export const ORDER_STATUS_LABELS = {
  new: 'New', awaiting_payment: 'Awaiting Payment', payment_pending: 'Payment Pending',
  paid: 'Paid', processing: 'Processing', dispatched: 'Dispatched', completed: 'Completed',
  cancelled: 'Cancelled', refunded: 'Refunded', manual_review: 'Manual Review',
};

export const PAYMENT_STATUS_LABELS = {
  pending: 'Pending', awaiting_payment: 'Awaiting Payment', successful: 'Successful',
  failed: 'Failed', cancelled: 'Cancelled', expired: 'Expired', manual_review: 'Manual Review',
  detected: 'Detected', confirming: 'Confirming', confirmed: 'Confirmed', refunded: 'Refunded',
};

export const JOURNAL_CATEGORIES = [
  'Research Education', 'Product Research', 'COA & Testing',
  'Industry News', 'Storage & Handling', 'Company Updates',
];

export const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  } catch { return iso; }
};

export function mdToHtml(md = '') {
  const esc = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const inline = (s) =>
    esc(s)
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/\*([^*]+)\*/g, '<em>$1</em>');
  const lines = md.split('\n');
  let html = '', list = null;
  const closeList = () => { if (list) { html += `</${list}>`; list = null; } };
  for (const raw of lines) {
    const line = raw.trimEnd();
    if (line.startsWith('### ')) { closeList(); html += `<h3>${inline(line.slice(4))}</h3>`; }
    else if (line.startsWith('## ')) { closeList(); html += `<h2>${inline(line.slice(3))}</h2>`; }
    else if (/^- /.test(line)) { if (list !== 'ul') { closeList(); html += '<ul>'; list = 'ul'; } html += `<li>${inline(line.slice(2))}</li>`; }
    else if (/^\d+\. /.test(line)) { if (list !== 'ol') { closeList(); html += '<ol>'; list = 'ol'; } html += `<li>${inline(line.replace(/^\d+\. /, ''))}</li>`; }
    else if (line.trim() === '') { closeList(); }
    else { closeList(); html += `<p>${inline(line)}</p>`; }
  }
  closeList();
  return html;
}

export const setPageMeta = (title, description) => {
  document.title = title ? `${title} | VQ Health` : 'VQ Health — UK Research Compounds';
  let m = document.querySelector('meta[name="description"]');
  if (m && description) m.setAttribute('content', description);
};
